/**
 * 配送追蹤地圖的底圖。兩個算繪層共用，換圖只改這裡一處。
 *
 * 用國土測繪中心「臺灣通用電子地圖（無等高線及門牌）」EMAP16：彩色、路網清楚、
 * 只標主要路名，而且沒有 POI 圖示轟炸。
 *
 * 評估時務必在 z14 前後比較，不要只看 z15。NLSC 各版本在不同縮放差很多：
 * z15 看起來乾淨的版本，到了 z14（配送員還有一兩公里時的視野）可能整片都是
 * 停車場與活動中心的圖示。我們實際最常停在 z14~16 之間。
 *
 * 實際在 z14 比較過的結果：
 * - EMAP98（新版）：POI 圖示與名稱鋪滿整張，路網幾乎看不見。z15 很好看，z14 崩潰。
 * - EMAPX99（無文字）：文字沒了，POI 圖示照樣鋪滿，路名也一併失去。
 * - EMAP（舊版全彩）：圖示與路名全開，最雜。
 * - EMAP01（灰階）：乾淨，但整張灰的不好看。
 * - EMAP16：和 EMAP01 一樣乾淨，但是彩色的。就是這個。
 */
const LAYER = "EMAP16";

export const BASEMAP_TILE_URL = `https://wmts.nlsc.gov.tw/wmts/${LAYER}/default/GoogleMapsCompatible/{z}/{y}/{x}`;
export const BASEMAP_ATTRIBUTION = '&copy; <a href="https://maps.nlsc.gov.tw/">國土測繪中心</a>';
export const BASEMAP_MAX_ZOOM = 19;

/**
 * 不再額外壓淡。灰階本身已經夠退後，再降透明度只會讓街名變得難讀——
 * 而街名正是選灰階版而不是無文字版的理由。
 */
export const BASEMAP_OPACITY = 1;
export const BASEMAP_BACKGROUND = "#ffffff";
